<template>
    <div class="send-join-invites">
        <common-page-header :heading="headerText" :isCenter="true" size="medium" class="header"></common-page-header>
        <!-- <import-contacts
            v-if="showImportContactsModal && inviteBy !== 'invite_by_phone'"
            :showAsInnerModal="true"
            :sendButtonLabel="$t('modals.send_join_invites_modal.import_contacts_modal.send_button')"
            @contacts-emails-collected="collectContactsEmails"
        ></import-contacts> -->
        <email-collector
            :label="label"
            :placeholder="placeholder"
            :buttonLabel="buttonLabel"
            :inviteBy="inviteBy"
            :initialNumOfFields="initialNumOfFields"
            :formData="formDataEmailFields"
            :valuePath="'emailFields'"
            :isLoading="isLoading"
            :isInviteToPractice="isInviteToPractice"
            @emails-collected="emailsCollected"
            @change="emailsChanged"
        ></email-collector>
        <common-notification ref="commonSuccessNotificationChild" :content="notificationMessage"></common-notification>
    </div>
</template>

<script>
    import EmailCollector from 'components/page-elements/network/EmailCollector'
    import UsersAPI from 'api/UsersAPI'
    import UserRolesEnum from '@/enums/UserRolesEnum'
    import InviteByEnum from '@/enums/InviteByEnum'

    export default {
        components: {
            EmailCollector,
        },
        props: {
            showImportContactsModal: { type: Boolean, required: false, default: false },
            headerText: { type: String, required: true },
            label: { type: String, required: true },
            placeholder: { type: String, required: true },
            buttonLabel: { type: String, required: true },
            initialNumOfFields: { type: Number, default: 3 },
            practiceType: { type: String, required: true },
            inviteBy: { type: String, required: false, default: InviteByEnum.INVITE_BY_EMAIL },
            isInviteToPractice: { type: Boolean, dafault: false },
        },

        data() {
            let sourceEmailFields = []
            let contactsData = []

            for (let i = 0; i < this.initialNumOfFields; ++i) {
                sourceEmailFields.push({
                    email: '',
                    error: '',
                })
            }

            return {
                sourceEmailFields,
                contactsData,
                notificationMessage: '',
                isLoading: false,
            }
        },

        computed: {
            formDataEmailFields() {
                return {
                    emailFields: this.sourceEmailFields,
                }
            },

            inviteByFields() {
                return [InviteByEnum.INVITE_BY_EMAIL, InviteByEnum.INVITE_BY_PHONE].map((value) => ({
                    label: this.$t(`modals.send_join_invites_modal.import_contacts_modal.${value}`),
                    value,
                }))
            },
        },
        methods: {
            invitationsSent() {
                this.notificationMessage = this.$t('modals.join_invites_member.invites_sent')
                this.$refs.commonSuccessNotificationChild.showNotification()
                this.emitEvent({ name: 'join-invites-sent' })
            },
            emailsChanged(ev) {
                this.sourceEmailFields = ev.value
            },
            emailsCollected(ev) {
                this.isLoading = true
                UsersAPI.checkJoinInvites(this.$auth.getActiveMember().id, ev, this.practiceType, this.inviteBy)
                    .then((response) => {
                        const checkProperty = this.inviteBy === InviteByEnum.INVITE_BY_PHONE ? 'phonesCheck' : 'emailsCheck'

                        if (
                            (response[checkProperty].invited && response[checkProperty].invited.length) ||
                            (response[checkProperty].registeredInvites && response[checkProperty].registeredInvites.length) ||
                            (response[checkProperty].registeredOther && response[checkProperty].registeredOther.length) ||
                            (response[checkProperty].registrationNotCompleted &&
                                response[checkProperty].registrationNotCompleted.length)
                        ) {
                            if (this.inviteBy === InviteByEnum.INVITE_BY_PHONE) {
                                if (response[checkProperty] && response[checkProperty].invited) {
                                    response[checkProperty].invited.forEach((invited) => {
                                        if (invited.phone) {
                                            UsersAPI.sendReminderForJoinInvite(
                                                this.$auth.getActiveMember().id,
                                                invited.id,
                                                'referral',
                                                'create-practice',
                                            ).then(() => {
                                                this.invitationsSent()
                                            })
                                        }
                                    })
                                }
                            } else {
                                this.$emit('check-emails-modal-show', {
                                    checkProperty: response[checkProperty],
                                    practiceType: this.practiceType,
                                })
                            }
                        } else if (
                            response[checkProperty].invited &&
                            response[checkProperty].invited.length === 0 &&
                            response[checkProperty].registeredInvites &&
                            response[checkProperty].registeredInvites.length === 0 &&
                            response[checkProperty].registeredOther &&
                            response[checkProperty].registeredOther.length === 0 &&
                            response[checkProperty].registrationNotCompleted &&
                            response[checkProperty].registrationNotCompleted.length === 0 &&
                            response[checkProperty].newInvitations &&
                            response[checkProperty].newInvitations.length
                        ) {
                            this.sendJoinInvites(response[checkProperty].newInvitations)
                        } else {
                            this.sendJoinInvites(ev.emails)
                        }
                    })
                    .catch((error) => {
                        this.$emit('join-invites-error', error.response)
                        this.isLoading = false
                    })
            },

            collectContactsEmails(conctactsEmails) {
                conctactsEmails.forEach((item) => {
                    item.emails.forEach((el) => {
                        const contact = {
                            firstName: item.firstName,
                            lastName: item.lastName,
                        }
                        if (el.inviteBy === InviteByEnum.INVITE_BY_EMAIL) {
                            contact.email = el.email
                            contact.inviteBy = InviteByEnum.INVITE_BY_EMAIL
                        } else {
                            contact.phone = el.email
                            contact.inviteBy = InviteByEnum.INVITE_BY_PHONE
                        }
                        this.sourceEmailFields.push(contact)
                    })
                })
                this.sourceEmailFields = this.sourceEmailFields.filter((emailFieds) => emailFieds.email !== '')
            },

            sendInvitesToNetwork(emails) {
                UsersAPI.createJoinNetworkInvites(
                    this.$auth.getActiveMember().id,
                    emails,
                    this.practiceType,
                    this.practiceType === 'physician' ? UserRolesEnum.PHYSICIAN.ID : null,
                )
                    .then(() => {
                        this.$emit('join-invites-sent', emails)
                    })
                    .catch((error) => {
                        this.$emit('join-invites-error', error.response)
                        this.isLoading = false
                    })
            },

            sendInvitesToPractice(emails) {
                UsersAPI.createJoinPracticeInvites({
                    userId: this.$auth.getActiveMember().id,
                    emails: emails,
                    practiceId: this.$auth.getPractice().id,
                })
                    .then(() => {
                        this.$emit('join-invites-sent', emails)
                    })
                    .catch((error) => {
                        this.$emit('join-invites-error', error.response)
                    })
            },

            sendJoinInvites(emails) {
                if (this.isInviteToPractice) {
                    return this.sendInvitesToPractice(emails)
                }
                this.sendInvitesToNetwork(emails)
            },
        },
    }
</script>

<style scoped>
    .send-join-invites {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .send-join-invites > .header {
        margin-bottom: 20px;
        text-align: center;
    }
</style>
